import { Platform } from "react-native";

export type FormDataFile = {
  uri: string;
  name?: string;
  type?: string;
};

function resolveFileMeta(file: FormDataFile): { name: string; type: string } {
  const rawName =
    file.name ||
    file.uri.split("/").pop()?.split("?")[0]?.split("#")[0] ||
    "";
  const hasExtension = /\.\w+$/.test(rawName);
  const name = hasExtension ? rawName : `file-${Date.now()}.jpg`;
  const type = file.type || "image/jpeg";

  return { name, type };
}

/**
 * Append a file to FormData in a platform-safe way.
 * Native RN accepts { uri, name, type }; web requires a real File/Blob.
 */
export async function appendFileToFormData(
  formData: FormData,
  fieldName: string,
  file: FormDataFile,
): Promise<void> {
  const { name, type } = resolveFileMeta(file);

  if (Platform.OS === "web") {
    const response = await fetch(file.uri);
    const blob = await response.blob();
    const upload = new File([blob], name, {
      type: type || blob.type || "application/octet-stream",
    });
    formData.append(fieldName, upload);
    return;
  }

  // React Native FormData accepts { uri, type, name }
  formData.append(fieldName, {
    uri: file.uri,
    name,
    type,
  } as unknown as Blob);
}
